enum StvPage {
    HOMEPAGE = 'HOMEPAGE',
    HOMEPAGE_FACELIFT = 'HOMEPAGE_FACELIFT',
    HOMEPAGE_DOGORAMA = 'HOMEPAGE_DOGORAMA',
    WIZARD = 'WIZARD',
    SESSION_INVALID = 'SESSION_INVALID',
    ERROR = 'ERROR'
}

export default StvPage;